import get from '../../../lib/requests';
import { CANCEL } from 'redux-saga';
import axios from 'axios';

export function requestGetAttributes(filters) {
	const ourRequest = axios.CancelToken.source();
	const promise = get(
		`api/newattributes?category=${filters.code}&brandcodes=${filters.brandCode}&singleattribute=${filters.singleattribute}&singlebrand=${filters.singlebrand}&&searchtxt=${filters.searchtext}&promotion=${filters.promotion}`,
		false,
		ourRequest.token
	);
	promise[CANCEL] = () => ourRequest.cancel();
	return promise;
}
